import React from 'react';
import { IIcon } from '../../interfaces/IIcon';
import { Icon } from '../Icon';

export function ChildrenIcon(props: IIcon) {
    const viewBoxProp = props.viewBox || '0 0 21 21';
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={viewBoxProp}
            style={props.style}
            className={props.className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.3636 13.3008C13.3636 13.3008 15.4545 15.3105 15.46 15.3134C16.1267 15.9584 15.9543 17.092 15.3219 17.7088L12.4054 20.6265C11.2788 21.7051 9.77353 20.208 10.8671 19.1637L12.7173 17.3861L10.9059 15.6608L13.3636 13.3008V13.3008ZM6.86084 13.3008V13.3008C6.86084 13.3008 4.773 15.3105 4.773 15.3134C4.1008 15.9584 4.27325 17.092 4.89842 17.7088L7.82788 20.6265C8.95005 21.7051 10.4556 20.208 9.36757 19.1637L7.52039 17.3861L9.31778 15.6608L6.86084 13.3008V13.3008ZM10.185 5.8246C11.8597 5.8246 13.2184 4.52364 13.2184 2.90821C13.2184 1.30228 11.86 0 10.185 0C8.50861 0 7.14716 1.30228 7.14716 2.90821C7.14716 4.52232 8.50724 5.8246 10.185 5.8246ZM13.472 12.1345L13.5163 10.1478L16.0384 12.4065C16.2436 12.5939 16.5071 12.6827 16.7706 12.6827C17.0553 12.6827 17.3446 12.5734 17.5553 12.3574C17.9599 11.9391 17.937 11.2882 17.5038 10.8998C17.5038 10.8998 14.6129 7.88363 14.197 7.53218C13.428 6.87735 12.3001 6.5061 10.4699 6.5061H9.89592C8.06442 6.5061 6.93785 6.87735 6.16581 7.53086C5.7516 7.88231 2.86036 10.8998 2.86036 10.8998C2.42882 11.288 2.40324 11.9391 2.80893 12.3574C3.01988 12.5734 3.3073 12.6827 3.5939 12.6827C3.85739 12.6827 4.12087 12.5939 4.32743 12.4065L6.84846 10.1491L6.89247 12.1356H13.4723V12.1345H13.472Z"
            />
        </Icon>
    );
}
